import ExaminationEventFinalization from './ExaminationEventFinalization';

export default ExaminationEventFinalization;
